<template>
  <div class="column_center_start member_banner" :class="{ 'vip': vipLevel > 1, 'general': vipLevel === 1 }">
    <div class="row_center_between" style="width: 100%; padding:10px 5% 0 3%;">
      <backButtonWhite />
      <vipMemberType class="member_type" v-if="vipLevel > 1"></vipMemberType>
      <generalMemberType class="member_type" v-else></generalMemberType>
    </div>
    <img :src="avatar" class="avatar" v-if="avatar" />
    <text class="row_center_center button-icon avatar" style="background-color: #eeeeee;"
      v-if="!avatar">account_circle</text>
  </div>
</template>
<script>
import generalMemberType from "./general/generalMemberType.vue";
import vipMemberType from "./general/vipMemberType.vue";
import backButtonWhite from "./backButtonWhite.vue";
export default {
  components: {
    generalMemberType,
    vipMemberType,
    backButtonWhite,
  },
  computed: {
    vipLevel() {
      return this.$store.getters["userData/vipLevel"]
    },
    getCurrentStore() {
      return this.$store.state.basic.currentStore;
    },
    avatar() {
      return this.$store.getters["userData/avatar"];
    }
  },
};
</script>
<style lang="scss" scoped>
.member_banner {
  width: 100%;
  height: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("@/assets/card_background2.png");
  margin-bottom: 70px;
  flex-shrink: 0;

  // .member_type {
  //   position: absolute;
  //   left: 8px;
  //   top: 10px;
  // }
}

.avatar {
  position: relative;
  top: -20px;
  margin: 0 auto;
  width: 118px;
  height: 118px;
  border-radius: 50%;
  border: 6px solid #facb00;
  font-size: 138px;
  color: #fff;
  flex-shrink: 0;
}

.vip {
  background-color: #000000;
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("@/assets/vip-card0206.png");
}

.general {
  background-color: #fd5001;
}
</style>
